// ====================
//  375px以下でviewportを固定にする
// ====================

function viewport() {
  const mediaQuery = window.matchMedia("(max-width: 375px)");
  const viewport = document.querySelector('meta[name="viewport"]');

  switchViewport(mediaQuery);
  mediaQuery.addEventListener("change", switchViewport);

  function switchViewport(mq) {
    if (mq.matches) {
      const value = window.outerWidth > 375 ? "width=device-width,initial-scale=1" : "width=375";
      if (viewport.content !== value) {
        viewport.content = value;
      }
    }
  }
}

export { viewport };
